module.exports = __webpack_public_path__ + "img/img-question-5-girl-with-headphones-on-laptop.96b4f191.jpg";